<template>
  <div class="app-container">
    <div class="title-row"><span class="title">{{ this.$route.meta.title }}</span></div>
    <el-form :model="queryParams" ref="qlcForm" size="small" :inline="true" v-show="showSearch" label-width="68px">
      <el-form-item label="起始期数">
        <el-input v-model="queryParams.startPeriod" placeholder="开始期数" clearable style="width: 100px;"/>
        -
        <el-input v-model="queryParams.endPeriod" placeholder="结束期数" clearable style="width: 100px;"/>
      </el-form-item>
      <el-form-item label="数字1" prop="num1">
        <el-input v-model="queryParams.num1" placeholder="数字1" clearable style="width: 80px;"/>
      </el-form-item>
      <el-form-item label="数字2" prop="num2">
        <el-input v-model="queryParams.num2" placeholder="数字2" clearable style="width: 80px;"/>
      </el-form-item>
      <el-form-item label="数字3" prop="num3">
        <el-input v-model="queryParams.num3" placeholder="数字3" clearable style="width: 80px;"/>
      </el-form-item>
      <el-form-item label="数字4" prop="num4">
        <el-input v-model="queryParams.num4" placeholder="数字4" clearable style="width: 80px;"/>
      </el-form-item>
      <el-form-item label="数字5" prop="num5">
        <el-input v-model="queryParams.num5" placeholder="数字5" clearable style="width: 80px;"/>
      </el-form-item>
      <el-form-item label="数字6" prop="num6">
        <el-input v-model="queryParams.num6" placeholder="数字6" clearable style="width: 80px;"/>
      </el-form-item>
      <el-form-item label="数字7" prop="num7">
        <el-input v-model="queryParams.num7" placeholder="数字7" clearable style="width: 80px;"/>
      </el-form-item>
      <el-form-item label="特别号码" prop="numSpecial">
        <el-input v-model="queryParams.numSpecial" placeholder="特别号码" clearable style="width: 80px;"/>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQueryQlc">搜索</el-button>
        <el-button icon="el-icon-refresh" size="mini" @click="resetQueryQlc">重置</el-button>
      </el-form-item>
    </el-form>
    <el-row :gutter="10" class="mb8">
      <el-col :span="1.5">
        <el-button v-hasPermi="['lottery:qlc:init']" type="primary" plain icon="el-icon-refresh-right" size="mini" @click="handleInitAllQlc">全部初始化
        </el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button v-hasPermi="['lottery:qlc:fill']" type="primary" plain icon="el-icon-refresh-right" size="mini" @click="handleFillQlcHistory">
          补全历史数据
        </el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button v-hasPermi="['lottery:qlc:count']" type="danger" plain icon="el-icon-data-line" size="mini" @click="handleQlcDataLine">号码频率
        </el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button v-hasPermi="['lottery:qlc:export']" type="warning" plain icon="el-icon-export" size="mini" @click="handleExportQlc">导出</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button v-hasPermi="['lottery:qlc:initC']" type="success" plain icon="el-icon-refresh-left" size="mini" @click="handleInitAllQlcC">
          初始化统计数据
        </el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button v-hasPermi="['lottery:qlc:exportC']" type="warning" plain icon="el-icon-export" size="mini" @click="handleOpenC()">导出统计数据
        </el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button v-hasPermi="['lottery:qlc:cache']" type="danger" plain icon="el-icon-export" size="mini" @click="handleRefreshQlc">刷新缓存</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button v-hasPermi="['lottery:qlc:gen']" type="success" plain icon="el-icon-refresh-left" size="mini" @click="handleOpenGenerateQlc">
          生成七乐彩
        </el-button>
      </el-col>
      <right-toolbar :show-search.sync="showSearch" @queryTable="getQlcList" />
    </el-row>
    <el-table :data="qlcList" v-loading="loading" border highlight-current-row
              :cell-class-name="cellClassName">
      <el-table-column label="期号" align="center" prop="period"/>
      <el-table-column label="数字号码" align="center">
        <el-table-column label="1" align="center" prop="num1"/>
        <el-table-column label="2" align="center" prop="num2"/>
        <el-table-column label="3" align="center" prop="num3"/>
        <el-table-column label="4" align="center" prop="num4"/>
        <el-table-column label="5" align="center" prop="num5"/>
        <el-table-column label="6" align="center" prop="num6"/>
        <el-table-column label="7" align="center" prop="num7"/>
      </el-table-column>
      <el-table-column label="特别号码" align="center" prop="numSpecial"/>
      <el-table-column label="奖池金额" align="right" prop="pondAmount" min-width="100px">
        <template slot-scope="scope">
          {{ formatYuan(scope.row.pondAmount) }}
        </template>
      </el-table-column>
      <el-table-column label="一等奖" align="center">
        <el-table-column label="注数" align="center" prop="firstCount"/>
        <el-table-column label="奖金(元)" align="right" prop="firstAmount" min-width="90px">
          <template slot-scope="scope">
            {{ formatYuan(scope.row.firstAmount) }}
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="二等奖" align="center">
        <el-table-column label="注数" align="center" prop="secondCount"/>
        <el-table-column label="奖金(元)" align="right" prop="secondAmount">
          <template slot-scope="scope">
            {{ formatYuan(scope.row.secondAmount) }}
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="销售金额" align="right" prop="saleAmount" min-width="100px">
        <template slot-scope="scope">
          {{ formatYuan(scope.row.saleAmount) }}
        </template>
      </el-table-column>
      <el-table-column label="开奖日期" align="center" prop="lotteryDate" min-width="90px">
        <template slot-scope="scope">
          {{ scope.row.lotteryDate | date }}
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="150px">
        <template slot-scope="scope">
          <el-button v-hasPermi="['lottery:qlc:win']" type="text" icon="el-icon-data-analysis" @click="handleWinning(scope.row)">概率</el-button>
          <el-button v-hasPermi="['lottery:qlc:next']" type="text" icon="el-icon-medal" @click="handleNextHistory(scope.row.period)">下期</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      v-show="qlcCount>0"
      :total="qlcCount"
      :page.sync="queryParams.current"
      :limit.sync="queryParams.size"
      @pagination="getQlcList"
      :page-sizes="[10, 20, 30, 50, 100, 200]"
    />
    <!-- 数字次数图表弹出层 -->
    <el-dialog :title="countTitle" :visible.sync="countOpen" width="1500px" @closed="countClosed"
               :close-on-click-modal="false">
      <div ref="redChart" style="width:100%;height: 300px;"></div>
      <div ref="blueChart" style="width:100%;height: 300px;margin-top: 20px"></div>
    </el-dialog>
    <!-- 导出统计次数弹出层 -->
    <el-dialog :title="cTitle" :visible.sync="cOpen" width="300px" :close-on-click-modal="false">
      <el-form ref="cForm" :model="cForm" :rules="cRules" label-width="110px" label-suffix="：">
        <el-form-item prop="isC">
                    <span slot="label">
                      是否排序
                      <el-popover
                        placement="top-start"
                        width="250"
                        trigger="hover"
                        content="如果排序为是，导出数据号码为历史出现次数从多到少的顺序;否则按照数据号码从小到大排序">
                        <i slot="reference" class="el-icon-question"></i>
                      </el-popover>
                    </span>
          <el-select v-model="cForm.isC" placeholder="请选择是否" style="width: 140px">
            <el-option :key="true" label="是" :value="true"></el-option>
            <el-option :key="false" label="否" :value="false"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="exportC">导出</el-button>
        <el-button @click="cancelC">取消</el-button>
      </div>
    </el-dialog>
    <!-- 生成七乐彩弹出层 -->
    <el-dialog title="生成七乐彩" :visible.sync="generateQlcOpen" width="750px" :close-on-click-modal="false">
      <el-form ref="generateQlcForm" :model="generateQlcForm" :inline="true" :rules="generateQlcRules"
               label-width="80px">
        <el-form-item label="生成个数" prop="count">
          <el-select v-model="generateQlcForm.count" placeholder="请选择个数">
            <el-option :key="1" label="1" :value="1"/>
            <el-option :key="5" label="5" :value="5"/>
            <el-option :key="10" label="10" :value="10"/>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" size="mini" @click="handleGenerateQlc">生成</el-button>
          <el-button icon="el-icon-refresh" size="mini" @click="resetGenerateQlc">重置</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="generateQlcList" border style="width: 100%" :cell-class-name="cellClassName"
                highlight-current-row>
        <el-table-column label="数字号码" align="center">
          <el-table-column label="1" align="center" prop="num1"/>
          <el-table-column label="2" align="center" prop="num2"/>
          <el-table-column label="3" align="center" prop="num3"/>
          <el-table-column label="4" align="center" prop="num4"/>
          <el-table-column label="5" align="center" prop="num5"/>
          <el-table-column label="6" align="center" prop="num6"/>
          <el-table-column label="7" align="center" prop="num7"/>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button v-hasPermi="['lottery:qlc:win']" type="text" icon="el-icon-data-analysis" @click="handleWinning(scope.row)">概率</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="close">关闭</el-button>
      </div>
    </el-dialog>
    <!-- 往期中奖概率弹出层 -->
    <el-dialog title="往期中奖概率" :visible.sync="winningOpen" width="500px">
      <el-row :gutter="20" v-for="(item,index) in winningList" :key="index" style="padding: 5px 0">
        <el-col :span="8">{{ item.name }}</el-col>
        <el-col :span="8">注数：{{ item.count }}</el-col>
        <el-col :span="8">概率：{{ formatMoney(item.winningRate * 100, 2) }}%</el-col>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="winningOpen=false">关 闭</el-button>
      </div>
    </el-dialog>
    <!-- 下期七乐彩同期历史数据弹出层 -->
    <el-dialog :title="qlcHistoryTitle" :visible.sync="qlcHistoryOpen" width="1500px" :close-on-click-modal="false">
      <el-tabs v-model="activeQlcHistoryName" type="border-card">
        <el-tab-pane label="历史同期数据" name="firstQlc">
          <el-table :data="qlcHistoryList" border style="width: 100%" :cell-class-name="cellClassName"
                    highlight-current-row>
            <el-table-column label="期数" align="center" prop="period" width="70"/>
            <el-table-column label="数字号码" align="center">
              <el-table-column label="1" align="center" prop="num1" width="60"/>
              <el-table-column label="2" align="center" prop="num2" width="60"/>
              <el-table-column label="3" align="center" prop="num3" width="60"/>
              <el-table-column label="4" align="center" prop="num4" width="60"/>
              <el-table-column label="5" align="center" prop="num5" width="60"/>
              <el-table-column label="6" align="center" prop="num6" width="60"/>
            </el-table-column>
            <el-table-column label="特别号码" align="center" prop="numSpecial" width="60"/>
            <el-table-column label="和值" align="center">
              <el-table-column label="数字" align="center" prop="redSum" width="60"/>
              <el-table-column label="总和" align="center" prop="totalSum" width="60"/>
            </el-table-column>
            <el-table-column label="数字跨度" align="center" prop="redSpan" width="70"/>
            <el-table-column label="数字奇数" align="center" prop="redOdd" width="70"/>
            <el-table-column label="数字偶数" align="center" prop="redEven" width="70"/>
            <el-table-column label="序号区间" align="center">
              <el-table-column label="一区(1-11)" align="center" prop="n1" width="100px"/>
              <el-table-column label="二区(12-22)" align="center" prop="n2" width="100px"/>
              <el-table-column label="三区(23-33)" align="center" prop="n3" width="100px"/>
            </el-table-column>
            <el-table-column label="次数区间" align="center">
              <el-table-column label="一区" align="center" prop="m1"/>
              <el-table-column label="二区" align="center" prop="m2"/>
              <el-table-column label="三区" align="center" prop="m3"/>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="统计数据" name="secondQlc">
          <el-row :gutter="10">
            <el-col :span="2" style="text-align: right">数字次数排名：</el-col>
            <el-col :span="22">
              <el-row :gutter="10">
                <el-col v-for="(item,index) in qlcHistoryRedList" :key="item.num" :span="2"><span
                  style="font-weight: bold">{{ index + 1 }}.</span> <span style="color: #d73a49">{{ item.num }}</span>
                  ({{ item.counts }}次)
                </el-col>
              </el-row>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="2" style="text-align: right">未出现的数字：</el-col>
            <el-col :span="22"><span v-for="item in qlcHistoryRedZeroList" :key="item">{{ item }} </span></el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="2" style="text-align: right">特别号码次数排名：</el-col>
            <el-col :span="22">
              <el-row :gutter="10">
                <el-col v-for="(item,index) in qlcHistoryBlueList" :key="item.num" :span="2"><span
                  style="font-weight: bold">{{ index + 1 }}.</span> <span style="color: #0000FF">{{ item.num }}</span>
                  ({{ item.counts }}次)
                </el-col>
              </el-row>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="2" style="text-align: right">未出现的特别号码：</el-col>
            <el-col :span="22"><span v-for="item in qlcHistoryBlueZeroList" :key="item">{{ item }} </span></el-col>
          </el-row>
        </el-tab-pane>
      </el-tabs>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="qlcHistoryOpen=false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  generateQlc,
  getNextQlcHistory,
  getQlcNumData,
  getQlcWinningData,
  initAllQlc,
  initAllQlcC,
  fillHistoryData,
  listQlc,
  refreshQlcCache
} from '@/api/lottery/qlc'
import * as echarts from 'echarts'

export default {
  data() {
    return {
      // 遮罩层
      loading: '',
      showSearch:true,
      //七乐彩数据
      qlcList: [],
      // 七乐彩数量
      qlcCount: 0,
      // 查询参数
      queryParams: {
        current: 1,
        size: 10,
        startPeriod: null,
        endPeriod: null,
        num1: null,
        num2: null,
        num3: null,
        num4: null,
        num5: null,
        num6: null,
        num7: null,
        numSpecial: null
      },
      countTitle: '',
      countOpen: false,
      redChart: {},
      blueChart: {},
      cTitle: '',
      cOpen: false,
      cForm: {},
      cRules: {
        isC: [
          {required: true, message: '是否不能为空', trigger: 'blur'}
        ]
      },
      generateQlcOpen: false,
      generateQlcForm: {
        count: 1
      },
      generateQlcRules: {
        count: [
          {required: true, message: '个数不能为空', trigger: 'blur'}
        ]
      },
      generateQlcList: [],
      winningList: [],
      winningOpen: false,

      activeQlcHistoryName: 'firstQlc',
      qlcHistoryOpen: false,
      qlcHistoryTitle: '',
      qlcHistoryList: [],
      qlcHistoryRedList: [],
      qlcHistoryRedZeroList: [],
      qlcHistoryBlueList: [],
      qlcHistoryBlueZeroList: [],
    }
  },
  created() {
    this.getQlcList()
  },
  methods: {
    cellClassName({row, column, rowIndex, columnIndex}) {
      if (column.property) {
        if (column.property === 'num1' || column.property === 'num2' || column.property === 'num3' || column.property === 'num4' || column.property === 'num5' || column.property === 'num6' || column.property === 'num7') {
          return 'red-ball';
        } else if (column.property === 'numSpecial') {
          return 'blue-ball';
        }
      }
    },
    /** 查询七乐彩列表 */
    getQlcList() {
      listQlc(this.queryParams).then(res => {
        this.qlcList = res.rows;
        this.total = res.total
      })
    },
    /** 搜索七乐彩列表 **/
    handleQueryQlc() {
      this.queryParams.current = 1;
      this.getQlcList()
    },
    /** 重置七乐彩按钮操作 */
    resetQueryQlc() {
      this.queryParams.startPeriod = undefined;
      this.queryParams.endPeriod = undefined;

      this.resetForm("qlcForm");
      this.handleQueryQlc();
    },
    /** 初始化七乐彩数据 **/
    handleInitAllQlc() {
      this.$modal.confirm("确定要初始化全部七乐彩数据吗？确认后将全部重新生成！").then(action => {
        if (action === 'confirm') {
          this.$modal.loading("正在初始化中，请稍后...")
          initAllQlc().then(res => {
            this.$modal.closeLoading()
            this.$modal.msgSuccess("初始化成功")
            this.handleQueryQlc();
          }).catch(()=>{
            this.$modal.closeLoading()
          })
        }
      }).catch(()=> {})
    },
    /** 补全七乐彩历史数据 **/
    handleFillQlcHistory() {
      this.$modal.confirm("确定要补全七乐彩历史数据吗？").then(action => {
        if (action === 'confirm') {
          this.$modal.loading("正在补全中，请稍后...")
          fillHistoryData().then(res => {
            this.$modal.closeLoading()
            this.$modal.msgSuccess("补全成功")
            this.handleQueryQlc();
          }).catch(()=>{
            this.$modal.closeLoading()
          })
        }
      }).catch(()=> {})
    },
    /** 七乐彩数据统计折线图 **/
    handleQlcDataLine() {
      this.countTitle = "七乐彩数据统计柱状图";
      getQlcNumData().then(res => {
        if (res.data.redData.length > 0) {
          let seriesData = res.data.redData.map(item => item.counts);
          let xAxisData = res.data.redData.map(item => item.num);
          this.redChart = echarts.init(this.$refs.redChart, "macarons");
          this.redChart.setOption({
            title: {
              text: '数字数据统计',
              left: 'center'
            },
            tooltip: {
              trigger: "axis",
              axisPointer: {
                type: "cross"
              }
            },
            color: ["#ff3c00"],
            grid: {
              left: "0%",
              right: "0%",
              bottom: "0%",
              top: "10%",
              containLabel: true
            },
            xAxis: {
              data: xAxisData
            },
            yAxis: {},
            series: [
              {
                name: "次数",
                type: "bar",
                data: seriesData,
                label: {
                  show: true,
                  position: 'top',
                  formatter: function (data) {
                    return data.value
                  }
                }
              }
            ]
          });
        }
        if (res.data.blueData.length > 0) {
          let seriesData = res.data.blueData.map(item => item.counts);
          let xAxisData = res.data.blueData.map(item => item.num);
          this.blueChart = echarts.init(this.$refs.blueChart, "macarons");
          this.blueChart.setOption({
            title: {
              text: '特别号码数据统计',
              left: 'center'
            },
            tooltip: {
              trigger: "axis",
              axisPointer: {
                type: "cross"
              }
            },
            color: ["#0077ff"],
            grid: {
              left: "0%",
              right: "0%",
              bottom: "0%",
              top: "10%",
              containLabel: true
            },
            xAxis: {
              data: xAxisData
            },
            yAxis: {},
            series: [
              {
                name: "次数",
                type: "bar",
                data: seriesData,
                label: {
                  show: true,
                  position: 'top',
                  formatter: function (data) {
                    return data.value
                  }
                }
              }
            ]
          });
        }
      })
      this.countOpen = true;
    },
    /** 导出大七乐彩按钮操作 */
    handleExportQlc() {
      this.download('/admin/lottery/qlc/export', {
        ...this.queryParams
      }, `七乐彩导出_${new Date().getTime()}.xlsx`)
    },

    /** 初始化七乐彩统计数据 **/
    handleInitAllQlcC() {
      this.$modal.confirm("确定要初始化七乐彩统计数据吗？").then(action => {
        if(action === 'confirm'){
          this.$modal.loading("正在初始化中，请稍后...")
          initAllQlcC().then(res => {
            this.$modal.closeLoading()
            this.$modal.msgSuccess("初始化成功")
            this.handleQueryQlc();
          }).catch(()=>{
            this.$modal.closeLoading()
          })
        }
      }).catch(()=>{ })
    },
    /** 刷新七乐彩缓存 **/
    handleRefreshQlc() {
      refreshQlcCache().then(() => {
        this.$modal.msgSuccess("刷新成功");
      })
    },
    /** 打开生成七乐彩弹窗 */
    handleOpenGenerateQlc() {
      this.generateQlcOpen = true;
      this.$set(this.generateQlcForm, 'count', 1)
      this.resetForm("generateQlcForm");
      this.generateQlcList = []
    },
    handleGenerateQlc() {
      this.$refs["generateQlcForm"].validate(valid => {
        if (valid) {
          generateQlc(this.generateQlcForm).then(res => {
            if (res.flag) {
              this.generateQlcList = res.data
            }
          })
        }
      })
    },
    resetGenerateQlc() {
      this.generateQlcList = []
      this.$set(this.generateQlcForm, 'count', 1)
      this.resetForm("generateQlcForm");
    },
    /** 获奖概率弹窗 **/
    handleWinning(row) {
      this.winningList = [];
      let queryParams = {
        num1: row.num1,
        num2: row.num2,
        num3: row.num3,
        num4: row.num4,
        num5: row.num5,
        num6: row.num6,
        num7: row.num7,
        numSpecial: row.numSpecial,
        period: row.period
      }
      getQlcWinningData(queryParams).then(res => {
        this.winningList = res.data
        this.winningOpen = true;
      })
    },
    /** 下期历史同期数据 **/
    handleNextHistory(period) {
      this.qlcHistoryList = [];
      this.qlcHistoryRedList = [];
      this.qlcHistoryRedZeroList = [];
      this.qlcHistoryBlueList = [];
      this.qlcHistoryBlueZeroList = [];
      getNextQlcHistory(period).then(res => {
        this.qlcHistoryList = res.data.lotteryDataList;
        this.qlcHistoryRedList = res.data.redList;
        this.qlcHistoryRedZeroList = res.data.redZeroList;
        this.qlcHistoryBlueList = res.data.blueList;
        this.qlcHistoryBlueZeroList = res.data.blueZeroList;
        this.qlcHistoryTitle = "【" + res.data.period + "】期七乐彩历史同期统计";
        this.qlcHistoryOpen = true;
      })
    },
    /** 打开导出彩票统计次数弹窗 **/
    handleOpenC() {
      this.cOpen = true;
      this.cTitle = "七乐彩统计数据导出";
    },
    /** 导出统计次数 **/
    exportC() {
      this.$refs["cForm"].validate(valid => {
        if (valid) {
          this.download('/admin/lottery/qlc/exportC', {
            ...this.cForm
          }, `七乐彩统计数据导出_${new Date().getTime()}.xlsx`)
        }
      });
    },
    cancelC() {
      this.cOpen = false;
      this.cForm = {};
      this.resetForm("cForm");
    },
    countClosed() {
      this.redChart.dispose();
      this.blueChart.dispose();
    },
    close() {
      this.generateQlcOpen = false;
    }
  }
}
</script>

